import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-tab-1",
  "use": "icon-tab-1-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"icon-tab-1\">\n  <path id=\"icon-tab-1_路径_9152\" data-name=\"路径 9152\" d=\"M96.734,100.224V97.611s0-.131-.262-.218a.7.7,0,0,0-.436.087c-.087.131-4.578,3.266-4.578,3.266a.806.806,0,0,0-.436.653.7.7,0,0,0,.305.61l4.578,3.135a1.369,1.369,0,0,0,.523.044.28.28,0,0,0,.262-.261v-2.439h4.447s3.531.479,3.531,1.785c0,0-.044-4.094-3.619-4.094m.262,10.452V113.2s.044.174.349.174c.174.044.305-.087.349-.087.087-.044,4.578-3.223,4.578-3.223a.806.806,0,0,0,.436-.653.7.7,0,0,0-.305-.61l-4.578-3.135a.493.493,0,0,0-.436-.044c-.305.087-.349.261-.349.261v2.439H96.821s-3.531-.479-3.531-1.785c0,0,.044,4.094,3.619,4.094\" transform=\"translate(-91.022 -97.385)\" fill=\"#727d98\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/tab-1.svg
// module id = bnhS
// module chunks = 102